import React, { useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap'
import { Modal } from 'react-bootstrap';
import NumericInput from 'react-numeric-input';

const OddResultCell = (props) => {
    const [show, setShow] = useState(false)
    const [backStake, setBackStake] = useState(100)
    const [layStake, setLayStake] = useState(100)
    const [betBackOdd, setBetBackOdd] = useState(null)
    const [betLayOdd, setBetLayOdd] = useState(null)

    const handleClose = () => setShow(false)
    const handleShow = () => {
        setBetBackOdd(backOdd)
        setBetLayOdd(layOdd)
        setShow(true)
    }
    const handleSubmit = () => setShow(true)

    const odds = props.odds;
    const backOdd = (odds && odds.bestBackOdd != null) ? odds.bestBackOdd : '-';
    const layOdd = (odds && odds.bestLayOdd != null) ? odds.bestLayOdd : '-';

    let contentBody = null
    if ((backOdd === '-' && layOdd === '-') || (backOdd === null && layOdd === null)) {
        contentBody = <>{'-,-'}</>
    } else {
        contentBody =
            <>
                <ButtonGroup size="sm">
                    <Button onClick={handleShow} style={{ fontSize: "10px", padding: "3px", backgroundColor: "#74BBEF" }}
                        variant="outline-dark"><b>{backOdd}</b></Button>
                    <Button onClick={handleShow} style={{ fontSize: "10px", padding: "3px", backgroundColor: "#F8AAB8" }}
                        variant="outline-dark"><b>{layOdd}</b></Button>
                </ButtonGroup>
                <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>West Indies Vs England</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="container">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Your Odds</th>
                                        <th>Your Stake</th>
                                        <th>P/L if Win</th>
                                        <th>P/L if Lose</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{ backgroundColor: "#74bcef" }}>
                                        <td>England</td>
                                        <td>
                                            <NumericInput onChange={(value) => setBetBackOdd(value)} size={{ width: "75px" }} step={0.1} precision={2} value={betBackOdd ?? backOdd} />
                                        </td>
                                        <td>
                                            <NumericInput onChange={(value) => setBackStake(value)} style={{ width: "75px" }} step={0.1} precision={2} value={backStake} />
                                        </td>
                                        <td>
                                            {((betBackOdd ?? backOdd) - 1) * backStake}
                                        </td>
                                        <td>
                                            {backStake}
                                        </td>
                                    </tr>
                                    <tr style={{ backgroundColor: "#f8aab8" }}>
                                        <td>England</td>
                                        <td>
                                            <NumericInput onChange={(value) => setBetLayOdd(value)} style={{ width: "75px" }} step={0.1} precision={2} value={betLayOdd ?? layOdd} />
                                        </td>
                                        <td>
                                            <NumericInput onChange={(value) => setLayStake(value)} style={{ width: "75px" }} step={0.1} precision={2} value={layStake} />
                                        </td>
                                        <td>
                                            {((betLayOdd ?? layOdd) - 1) * layStake}
                                        </td>
                                        <td>
                                            {layStake}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                        <Button variant="primary" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
    }
    return (
        contentBody
    )
}

export default OddResultCell;
